import { ref } from "@vue/reactivity";
import NavBar from "@/view/components/nav-bar/nav-bar";
import SessionUtil from "@/utils/SessionUtil";
import SettingApi from "@/api/setting-api";
import RouterUtil from "@/utils/RouterUtil";
import StorageUtil from "@/utils/StorageUtil";
import Config from "@/config";
import { closeToast, showLoadingToast } from "vant";
export default {
  name: "UserCommute",
  components: {
    NavBar
  },
  setup() {
    const title = ref("通勤设置");
    const userData = ref();
    const setting = ref(SettingApi.getDefaultConfig());
    return {
      title,
      userData,
      setting
    };
  },
  mounted() {
    this.userData = SessionUtil.getUserData();
    this.getUserSetting();
  },
  methods: {
    goAddressMapSelect(type) {
      let position = Config.defaultPosition;
      if (type === "home" && this.setting.homeAddress && this.setting.homeAddress.length > 0) {
        position = [this.setting.homeAddressLongitude, this.setting.homeAddressLatitude];
      }
      if (type === "work" && this.setting.workAddress && this.setting.workAddress.length > 0) {
        position = [this.setting.workAddressLongitude, this.setting.workAddressLatitude];
      }
      StorageUtil.setObject("positionData", {
        type: type,
        point: position
      });
      StorageUtil.setObject("settingData", this.setting);
      RouterUtil.go("/address/map-select", false, this.$route.path);
    },
    getUserSetting() {
      const that = this;
      showLoadingToast({
        duration: 0,
        // overlay: true,
        forbidClick: true,
        message: '正在加载...'
      });
      SettingApi.getSetting().then(function (result) {
        if (result.setting) {
          that.setting = result.setting;
        }
      }).catch(function (error) {}).finally(function () {
        // that.isWatchSetting = true;
        closeToast();
        const addressData = StorageUtil.getObject("addressData");
        if (addressData) {
          if (addressData.type === "home") {
            that.setting.homeAddress = addressData.address;
            that.setting.homeAddressLongitude = addressData.position[0];
            that.setting.homeAddressLatitude = addressData.position[1];
          }
          if (addressData.type === "work") {
            that.setting.workAddress = addressData.address;
            that.setting.workAddressLongitude = addressData.position[0];
            that.setting.workAddressLatitude = addressData.position[1];
          }
          SettingApi.setSetting(that.setting);
          StorageUtil.remove("addressData");
          that.$forceUpdate();
        }
      });
    }
  }
};